import { useEffect, useReducer, useState } from "react";
import {
  AppShell,
  Burger,
  useMantineTheme,
  Group,
  ScrollArea,
  rem,
  Drawer,
  Image,
  Divider,
  Title,
  UnstyledButton,
  Flex,
  Container,
  Center,
} from "@mantine/core";
import "./DashboardLayout.css";

import logo from "../assets/android-chrome-192x192.png";
import { Link, Outlet, useNavigate } from "react-router-dom";
import { useDisclosure } from "@mantine/hooks";
import { IconAlertCircle } from "@tabler/icons-react";
import { notifications } from "@mantine/notifications";
import MenuUser from "../components/MenuUser";


interface LinksGroupProps {
  icon: string;
  label: string;
  initiallyOpened: boolean;
  link: string;
  links: { label: string; link: string }[];
}

interface RowDataUser {
  id: string;
  url: string;
  faculty: string;
  programe: string;
  short_name: string;
  role: string;
  name: string;
}

const initialmockdata: LinksGroupProps[] = [];



function DashboardLayout() {

  const theme = useMantineTheme();
  const [opened, { toggle }] = useDisclosure();
  const [mockdata, setmockdata] = useState(initialmockdata);

  const [drawerOpened, { toggle: toggleDrawer, close: closeDrawer }] =
    useDisclosure(false);

  const initialState = {
    loading: "",
    error: "",
    data: [],
  };

  function apiReducer(state: any, action: any) {
    switch (action.type) {
      case "DATA_FETCH_START":
        return { ...state, loading: "yes" };
      case "DATA_FETCH_SUCCESS":
        return { ...state, loading: "", data: action.payload };
      case "DATA_FETCH_FAILURE":
        return { ...state, loading: "", error: action.payload };
      default:
        return state;
    }
  }

  const [data, dispatch] = useReducer(apiReducer, initialState);
  const [dataUser, SetdataUser] = useState<RowDataUser>();


  const nav = useNavigate();
  const [checkLoad, setCheckLoad] = useState(false);
  const signOut = () => {
    notifications.show({
      title: "แจ้งเตือน",
      message: "ไม่มีสิทธิ์เข้าใช้งานในส่วนนี้",
      autoClose: 3000,
      icon: <IconAlertCircle />,
      color: "red",
    });
    nav(`/`);
    window.localStorage.clear();
  };

  const checkData = () => {
    setCheckLoad(true);
  };

  useEffect(() => {
    checkData();
    if (checkLoad) {
      if (localStorage.getItem("dataUser") === null) {
        signOut();
      }
    }
  }, [checkLoad]);

  const LoadPage = () => {
    let rr: any = localStorage.getItem("dataUser");
    SetdataUser(JSON.parse(rr));
  };

  useEffect(() => { }, []);

  useEffect(() => {
    LoadPage();
  }, []);


  return (
    <AppShell
      header={{ height: 60 }}
      padding="md"
    >
      <AppShell.Header>


        <Group justify="space-between" p="xs" align="center" h={'100%'}>
          <UnstyledButton component={Link} to="/dashboard">
            <Group justify="flex-start" align="center">
              <Image src={logo} w={40}></Image>
              <Title order={5} c="dimmed">
                ลงทะเบียนซ้อมรับพระราชทานปริญญาบัตร
              </Title>
            </Group>

          </UnstyledButton>
          <MenuUser
            image={`${dataUser?.url}`}
            name={`${dataUser?.name}`}
            type="บัณฑิต"
          />
        </Group>



      </AppShell.Header>
      <AppShell.Main>
        <Center w="100%">
          <Outlet />
        </Center>
      </AppShell.Main>

    </AppShell>


  );
}

export default DashboardLayout;
